import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import {
  csvReducer,
  sidebarReducer,
  themeReducer,
  customizerReducer,
  userReducer,
  usersReducer,
  accountReducer,
  accountsReducer,
  messageReducer,
  productsReducer,
  industriesReducer,
  contactsReducer,
  campaignReducer,
  campaignsReducer,
  clientCampaignsReducer,
  errorsReducer,
  scheduleReducer,
  schedulesReducer,
  sequenceReducer,
  sequencesReducer,
  outreachReducer,
  outreachesReducer,
  destroyModalReducer,
  csvTemplatesReducer,
  toggleModalReducer,
  organizationEmailConfigsReducer,
  emailConfigsReducer,
  emailConfigReducer,
  subscriptionReducer,
  subscriptionsReducer,
  subscriptionTypesReducer,
  csvTemplateFieldsReducer,
  subscriptionProductsReducer,
  sequenceContactReducer,
  sequenceContactsReducer,
  accountBlacklistedContactReducer,
  stepReducer,
  stepsReducer,
  pitchReducer,
  pitchesReducer,
  templatePitchesReducer,
  templatePitchReducer,
  pitchQualityMetricsReducer,
  sequencePendingContactsReducer,
  accountContactsReducer,
  reportReducer,
  messagesReducer,
  configReducer,
  contactPitchPreviewsReducer,
  previewContactsReducer,
  contactsCSVReducer,
  contactReducer,
  dashboardReducer,
  createCampaignStateReducer,
  timelineReducer,
  outletsReducer,
  mentionReducer,
  opportunityReducer,
  opportunityOneReducer,
  dropdownContactsReducer,
} from './reducers';

const middlewares = [thunk, promise];

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  products: productsReducer,
  industries: industriesReducer,
  theme: themeReducer,
  sidebar: sidebarReducer,
  customizer: customizerReducer,
  organizationEmailConfigs: organizationEmailConfigsReducer,
  account: accountReducer,
  accountEmailConfigs: emailConfigsReducer,
  accountEmailConfig: emailConfigReducer,
  accounts: accountsReducer,
  message: messageReducer,
  messages: messagesReducer,
  user: userReducer,
  users: usersReducer,
  errors: errorsReducer,
  campaign: campaignReducer,
  campaigns: campaignsReducer,
  clientCampaigns: clientCampaignsReducer,
  sequence: sequenceReducer,
  sequences: sequencesReducer,
  step: stepReducer,
  steps: stepsReducer,
  pitch: pitchReducer,
  contactPitchPreviews: contactPitchPreviewsReducer,
  pitches: pitchesReducer,
  templatePitch: templatePitchReducer,
  templatePitches: templatePitchesReducer,
  pitchQualityMetrics: pitchQualityMetricsReducer,
  schedule: scheduleReducer,
  schedules: schedulesReducer,
  contacts: contactsReducer,
  dropdownContacts: dropdownContactsReducer,
  outreach: outreachReducer,
  outreaches: outreachesReducer,
  // csv
  csv: csvReducer,
  csvTemplates: csvTemplatesReducer,
  csvTemplateFields: csvTemplateFieldsReducer,
  // subscriptions
  subscriptions: subscriptionsReducer,
  subscription: subscriptionReducer,
  subscriptionTypes: subscriptionTypesReducer,
  subscriptionProducts: subscriptionProductsReducer,
  destroyModal: destroyModalReducer,
  toggleModal: toggleModalReducer,
  // contacts
  sequenceContact: sequenceContactReducer,
  sequenceContacts: sequenceContactsReducer,
  accountContacts: accountContactsReducer,
  accountBlacklistedContact: accountBlacklistedContactReducer,
  sequencePendingContacts: sequencePendingContactsReducer,
  previewContacts: previewContactsReducer,
  contactsCSV: contactsCSVReducer,
  contact: contactReducer,
  // outlets
  outlets: outletsReducer,
  // report
  report: reportReducer,
  // config
  config: configReducer,
  dashboard: dashboardReducer,
  createCampaignState: createCampaignStateReducer,
  timelines: timelineReducer,
  mentions: mentionReducer,
  opportunities: opportunityReducer,
  opportunity: opportunityOneReducer,
});

// eslint-disable-next-line
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  composeEnhancer(applyMiddleware(...middlewares)),
);

export default store;
